import {
  Box,
  HStack,
  Icon,
  Image,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { RiInstanceLine } from "@remixicon/react";
import { useBgHover } from "../../../themes/colors";
import ResellersModal from "../../product_page/ResellersModal";

interface EssentialProductCardPropsInterface {
  imageSrc: string;
  category: string;
  name: string;
  lowestPrice: string;
  slug: string;
}

const EssentialProductCard = ({
  imageSrc,
  category,
  name,
  lowestPrice,
  slug,
}: EssentialProductCardPropsInterface) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const bgHover = useBgHover();

  return (
    <>
      <Box
        p={2}
        borderRadius={["md", null, "lg"]}
        cursor={"pointer"}
        onClick={onOpen}
        _hover={{ bg: bgHover }}
      >
        <Image
          src={imageSrc}
          fallbackSrc="/assets/svg/illustration_empty.svg"
          alt={name}
          aspectRatio={1.5 / 1}
          w={"full"}
          objectFit="cover"
          borderRadius="md"
        />

        <HStack mt={4}>
          <Icon as={RiInstanceLine} />

          <Text
            textStyle={"b-sm"}
            variant={"secondary"}
            noOfLines={1}
            textOverflow={"ellipsis"}
          >
            {category}
          </Text>
        </HStack>

        <Text
          mt={1}
          textStyle={"b-reg-sb"}
          noOfLines={1}
          textOverflow={"ellipsis"}
        >
          {name}
        </Text>

        <Text mt={1} textStyle={"b-sm-sb"} color={"red.400"}>
          {lowestPrice}
        </Text>
      </Box>

      <ResellersModal isOpen={isOpen} onClose={onClose} productSlug={slug} />
    </>
  );
};

export default EssentialProductCard;
